import kindsSportsBySchool from '@/store/modules/kinds-sports/kinds-sports-by-school'

export default {
  kindsSportsBySchool,
}
